import React, { useEffect } from "react";
import styles from "./Landing.module.scss";
import Hero from "../Hero/Hero";
import About from "../About/About";
import Offer from "../Offer/Offer";
import DanceStyles from "../DanceStyles/DanceStyles";
import Footer from "../Footer/Footer";
import Contact from "../Contact/Contact";
import { useLocation } from "react-router-dom";

const Landing = () => {
  return (
    <main className={styles.container}> {/* Dodajemo <main> kao landmark */}
      <Hero />
      <About />
      <Offer />
      <DanceStyles />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;